import axios from 'axios'
import { ServerEnv } from 'Configs/ServerEnv'
import { DomainConfig } from 'Configs/DomainConfig'
import StoreCountry from 'GlobalStores/Cores/County/StoreCountry'
import HttpHelper from 'Services/HttpHelper'

const CreatePaymentData = (uuid, countryCode3alpha) => {
    const url = `${ServerEnv.MemberCalls2()}/hot/payment_router/hydra-value/feelGreat/${StoreCountry.Country3()}`

    const data = {
        uuid: uuid,
        source_path: window.location.href
    }

    return axios.post(HttpHelper.Proxy({ originalUrl: url }), data, {
        headers: {
            'Content-Type': 'application/json'
        }
    })
}

const CreatePaymentLambdaData = (uuid, countryCode3alpha) => {
    const url = `${ServerEnv.MemberCalls2()}/hot/format/${StoreCountry.Country3()}/feelGreat/detail-hydra-v2/${uuid}`

    return axios.get(HttpHelper.Proxy({ originalUrl: url }), {
        headers: {
            'Content-Type': 'application/json'
        }
    })
}

const CreateMemberAndOrder = hydraData => {
    const url = `${ServerEnv.Hydra()}/orders`

    return axios.post(HttpHelper.Proxy({ originalUrl: url }), hydraData, {
        headers: {
            'Content-Type': 'application/json',
            'X-Application': DomainConfig.getXApplication(StoreCountry.Country2())
        }
    })
}

const CreateOrder = (hydraData, token, Language, c) => {
    const url = `${ServerEnv.Hydra()}/customers/me/orders`
    return axios.post(HttpHelper.Proxy({ originalUrl: url }), hydraData, {
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
            'X-Application': DomainConfig.getXApplication(StoreCountry.Country2())
        }
    })
}

const CreateLambdaOrder = (lambdaData, token, Language, c) => {
    const url = `${ServerEnv.MemberCalls2()}/hot/payment_router/proxy/insert/${StoreCountry.Country3()}`
    return axios.post(HttpHelper.Proxy({ originalUrl: url }), lambdaData, {
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`
        }
    })
}

const CreateWorldPayOrder = (hydraData, token) => {
    const url = `${ServerEnv.Hydra()}/customers/me/orders`
    // test Zone
    // const url = `https://hydraqa.unicity.net/v5a-test/customers/me/orders`

    // hydraData['lines'] = {
    //     items: [
    //         {
    //             item: {
    //                 href: 'https://hydraqa.unicity.net/v5a-test/items?id.unicity=35571'
    //             },
    //             quantity: 1
    //         }
    //     ]
    // }
    // test Zone

    return axios.post(HttpHelper.Proxy({ originalUrl: url }), hydraData, {
        headers: {
            'Content-Type': 'application/json',
            // Authorization: `Bearer `
            Authorization: `Bearer ${token}`,
            'X-Application': DomainConfig.getXApplication(StoreCountry.Country2())
        }
    })
}

const CreateAutoship = (autoOrder, token) => {
    const url = `${ServerEnv.Hydra()}/customers/me/autoorders`

    return axios.post(HttpHelper.Proxy({ originalUrl: url }), autoOrder, {
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
            'X-Application': DomainConfig.getXApplication(StoreCountry.Country2())
        }
    })
}

const PostSms = dataSms => {
    const smsApi = `${ServerEnv.MemberCalls2()}/sms-api/sms`

    axios
        .post(HttpHelper.Proxy({ originalUrl: smsApi }), dataSms, {
            headers: {
                'Content-Type': 'application/json'
            }
        })
        .catch(error => console.error(error))
}

const UpdateLog = data => {

    const url = `${ServerEnv.MemberCalls2()}/hot/payment_router/hydra-log`

    return axios.post(HttpHelper.Proxy({ originalUrl: url }), data, {
        headers: {
            'Content-Type': 'application/json'
        }
    })
}

const PostEmail = dataEmail => {
    const emailApi = `${ServerEnv.MemberCalls2()}/email-api/message`

    axios
        .post(HttpHelper.Proxy({ originalUrl: emailApi }), dataEmail, {
            headers: {
                'Content-Type': 'application/json'
            }
        })
        .catch(error => console.error(error))
}

const CustomerLogin = (username, password, timeout = 0) => {
    let data = {
        type: 'base64',
        value: btoa(`${username}:${password}`),
        namespace: `${ServerEnv.Hydra()}/customers`
    }

    const url = `${ServerEnv.Hydra()}/loginTokens`

    return axios.post(HttpHelper.Proxy({ originalUrl: url }), data, {
        headers: {
            'Content-Type': 'application/json',
            'X-Application': DomainConfig.getXApplication(StoreCountry.Country2())
        }
    })
}

const GetPaymentDetail = (paymentId, baId) => {
    const data = {
        payment_id: paymentId,
        type: baId ? 'shop' : 'enroll',
        ba_id: baId || ''
    }
    const url = `${ServerEnv.MemberCalls2()}/hot/payment_router/detail/hydra`

    return axios.post(HttpHelper.Proxy({ originalUrl: url }), data)
}

const GetPaymentProxyDetail = gateway_ref_id => {
    const data = {
        gateway_ref_id: gateway_ref_id
    }
    const url = `${ServerEnv.MemberCalls2()}/hot/payment_router/detail/proxy`

    return axios.post(HttpHelper.Proxy({ originalUrl: url }), data)
}

const UpdateLogByOrder = data => {
    const url = `${ServerEnv.MemberCalls2()}/hot/payment_router/hydra-log-by-order`

    return axios.post(HttpHelper.Proxy({ originalUrl: url }), data, {
        headers: {
            'Content-Type': 'application/json'
        }
    })
}

const GetOrderDetailByOrderNumber = orderNumber => {
    const url = `${ServerEnv.MemberCalls2()}/hot/formatV2/order/data?order_number=${orderNumber}`

    return axios.get(HttpHelper.Proxy({ originalUrl: url }))
}

const RequestWorldPayDDC = bin => {
    const url = `${ServerEnv.Hydra()}/ddc`
    // const url = `https://hydraqa.unicity.net/v5a-test/ddc`
    return axios.post(
        HttpHelper.Proxy({ originalUrl: url }),
        {
            bin
        },
        {
            headers: {
                'Content-Type': 'application/json',
                'X-Application': DomainConfig.getXApplication(StoreCountry.Country2())
            }
        }
    )
}

const GetHydraOrderDetail = async (orderNunber, token) => {
    const url = `${ServerEnv.Hydra()}/orders?id.unicity=${orderNunber}`
    // const url = `https://hydraqa.unicity.net/v5a-test/orders?id.unicity=${orderNunber}`
    return axios.get(HttpHelper.Proxy({ originalUrl: url }), {
        headers: {
            // Authorization: `Bearer `
            Authorization: `Bearer ${token}`,
            'X-Application': DomainConfig.getXApplication(StoreCountry.Country2())
        }
    })
}

const UpdateLambdaAutoshipLog = data => {
    const url = `${ServerEnv.MemberCalls2()}/hot/payment_router/proxy-log-autoship
    `

    return axios.post(HttpHelper.Proxy({ originalUrl: url }), data, {
        headers: {
            'Content-Type': 'application/json'
        }
    })
}

export const PaymentAPIs = {
    CreatePaymentData,
    CreatePaymentLambdaData,
    CreateMemberAndOrder,
    CreateOrder,
    CreateLambdaOrder,
    PostSms,
    UpdateLog,
    PostEmail,
    CustomerLogin,
    GetPaymentDetail,
    GetPaymentProxyDetail,
    CreateAutoship,
    UpdateLogByOrder,
    GetOrderDetailByOrderNumber,
    CreateWorldPayOrder,
    RequestWorldPayDDC,
    GetHydraOrderDetail,
    UpdateLambdaAutoshipLog
}
